module.exports = __webpack_public_path__ + "18c517ee855743bcbaf27d339c6051d7.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/franchises/sm_image_2_0.png
// module id = 141
// module chunks = 0